export const realtimeState: IRealtimeState = {
  isEnabled: false,
  isReady: false,
  subtitles: '',
  subtitlesTs: 0,
  stageType: 'ground',
  stageSize: 'medium',
  isStyleTransferDialogOpen: false,
  styleTransferStyle: '',
  styleTransferHideFloor: false,
  sceneBackgroundOn: false,
  styleTransferImageId: '',
  sceneIntructions: '',
  tileArea: {
    from: {
      x: 0,
      y: 0,
    },
    to: {
      x: 0,
      y: 0,
    },
  },
};
